{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "签出",
      "checkInDeprecated": "签到（已弃用）",
      "checkIn": "签到",
      "receivedLoadInspection": "收货检查",
      "shippedLoadVerification": "发货核验",
      "appointmentsPerLoadType": "按货物类型预约",
      "assetDetails": "资产详情",
      "yardManagementSystem": "堆场管理系统",
      "smartGateIntegration": "SmartGate 集成",
      "gateManagement": "闸口管理",
      "idValidation": "身份验证",
      "appointmentCompleted": "预约已完成"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "默认将收集<strong>电话号码</strong>和<strong>承运公司</strong>"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "收集司机在计划内和计划外到达时的签到详情。",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "在预约完成后收集签出数据。",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "在司机为计划内预约自助签到时收集其信息。此功能是我们闸口管理解决方案的可选附加功能。",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "记录与所收货物相关的损坏、差异或其他问题。",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "记录与所发货物相关的货物完整性及其他安全措施。",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "在预约时收集特定于货物类型的详细信息。",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "在拖车和集装箱到达您的堆场时存储并跟踪其详细信息。",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "为该仓库启用 YMS 模块，同时为闸口管理应用启用资产到访字段。",
      "enableTheSmartGateModuleForThisWarehouse": "为该仓库启用 SmartGate 模块。",
      "enableTheIdValidationForThisWarehouse": "为该仓库启用身份验证模块。",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "为该仓库启用闸口管理模块，其中包括签到",
      "reviewAndManageAppointmentDataAfterCompletion": "在预约完成后查看和管理预约数据。"
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">了解工作原理</a>，或联系我们<a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">申请试用</a>。",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">了解工作原理。</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "司机在自助签到时将看到此表单。",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "此表单上的所有字段在预约时都将<strong>可用且可见</strong>。"
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "司机在自助签到时将不会看到此表单。",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "此表单上的所有字段在预约时都将<strong>不可用</strong>。<br />您可以随时重新启用此表单。"
    },
    "labels": {
      "updateClaimsSupport": "更新索赔支持",
      "selectAClaimsSupportToUpdate": "选择要更新的索赔支持",
      "damageType": "损坏类型",
      "damageDescription": "损坏描述",
      "damagePhotos": "损坏照片",
      "discrepancyType": "差异类型",
      "discrepancyDescription": "差异描述",
      "discrepancyPhotos": "差异照片",
      "loadSecurityChecked": "已检查货物安全",
      "loadSecurityDescription": "货物安全描述",
      "loadIntegrityPhotos": "货物完整性照片",
      "sealIntegrityPhotos": "封条完整性照片"
    }
  }
}
